export default class DtoPiezoMeasureLight {
    constructor(obj) {
        this.date = obj[0] // DateTime
        this.value = obj[1] // Option[Double]
        this.NGF = obj[1]
        this.codepoint = obj[2] // Option[Int]
        this.status = obj[3] // Option[Int]
        this.qualification = obj[4] // Option[Int]
        this.initialPoint = obj[5] // Option[Int]
    }
}